import React from "react";
import "./Loader.scss";
import { Svg } from "app/components/svg";

const Loader = ({ isContained }) => (
  <div
    className="pulse-container"
    style={
      isContained
        ? {
            ...styles.pulseContainerStyles,
          }
        : null
    }
  >
    <div
      className="pulse-wrapper"
      style={
        isContained
          ? {
              ...styles.pulseWrapperStyles,
            }
          : null
      }
    >
      <center>
        <div className="pulse-loader">
          <Svg
            iconName="icon-digipay-loader"
            className="icon icon-digipay-loader"
          />
          <div className="pulsers">
            <div className="pulse" />
            <div className="pulse" />
            <div className="pulse" />
          </div>
        </div>
      </center>
    </div>
  </div>
);

const styles = {
  pulseContainerStyles: {
    position: "relative !important",
    top: "0 !important",
    left: "0 !important",
    transform: "none !important",
  },
  pulseWrapperStyles: {
    position: "relative !important",
    top: "0 !important",
    left: "0 !important",
    transform: "none !important",
  },
};

export default Loader;
